import BaseComponent from '@components/base-component';
import ErrorPage from '@components/error-page/error-page';
import Message from '@components/message/message';
import Modal from '@components/modal/modal';
import OptionsList from '@components/options-list/options-list';
import Picker from '@components/picker/picker';
import tag from '@components/utility-components';
import * as styles from './page.module.scss';
export default class Page extends BaseComponent {
    machine;
    modal;
    optionsList;
    picker;
    errorPage;
    content;
    constructor(machine, linkHandler) {
        super({ elementTag: 'main', classes: [styles.page] });
        this.machine = machine;
        this.modal = new Modal();
        this.optionsList = new OptionsList(machine, this.modal.modalControls, linkHandler, this.showMessage.bind(this));
        this.picker = new Picker(machine, linkHandler, this.showMessage.bind(this));
        this.errorPage = new ErrorPage(linkHandler);
        this.content = tag.div({ classes: [styles.content] });
        this.appendChildren(tag.h1({ text: 'Decision Making Tool', classes: [styles.heading] }), this.content);
        this.machine.on(this.machine.events.machineStateChanged, this.handleRouteChange.bind(this));
    }
    mount() {
        this.handleRouteChange();
        document.body.append(this.getElement());
    }
    showMessage(messageType) {
        this.modal.showModal(new Message(this.modal.modalControls, messageType));
    }
    handleRouteChange() {
        const { currentRoute } = this.machine.context;
        if (currentRoute === '/')
            this.changeContent(this.optionsList);
        else if (currentRoute === '/picker')
            this.changeContent(this.picker);
        else
            this.changeContent(this.errorPage);
    }
    changeContent(newContent) {
        this.content.getElement().replaceChildren(newContent.getElement());
    }
}
